import { Component, OnInit, EventEmitter, Input } from '@angular/core';

import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { Subject } from 'rxjs';
import { AccountService } from 'src/app/services/account-services';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatError } from '@angular/material/form-field';
import { ToastrService } from 'src/app/services/toast-service';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
    standalone: true,
    selector: 'session-expired',
    templateUrl: './session-expired.component.html',
    styleUrls: ['./session-expired.component.css'],
    imports: [ReactiveFormsModule, MatInputModule, MatFormFieldModule, CommonModule,
        MatIconModule, MatButtonModule, MatError
    ],
})
export class ModalSessionExpiredComponent implements OnInit {

    onClose = new EventEmitter<{ Status: boolean }>();

    loginForm!: FormGroup;

    @Input() userName: string = '';


    constructor(public ModalRef: BsModalRef,
        private router: Router,
        private toastr: ToastrService,
        public accountService: AccountService,
        private route: ActivatedRoute,

    ) { }
    confirmContinue() {
        this.onClose.emit({ Status: true });
    }
    ngOnInit() {
        this.loginForm = new FormGroup({
            name: new FormControl(this.userName || '', Validators.required),
            password: new FormControl('', Validators.required),
        });
    }


    goToLogin() {
        localStorage.clear();
        this.onClose.next({ Status: false });
        this.ModalRef.hide();
    }

    ifLogin() {
        if (this.loginForm.valid) {
            const loginData = this.loginForm.getRawValue();



            this.accountService.login(loginData).subscribe(
                (response: any) => {
                    this.toastr.success('Login successful');
                    localStorage.removeItem('sessionExpired');
                    localStorage.setItem('userType', response.role);
                    localStorage.setItem('accessToken', response.accessToken);
                    localStorage.setItem('userName', response.name);

                    if (response.role !== "SA") {

                        this.router.navigate(['/patient-list'])

                    } else {
                        this.router.navigate(['/instance-management'])

                    }
                    this.onClose.next({ Status: false });
                    this.ModalRef.hide();
                },
                ({ error }: any) => {
                    const errorMessage = error?.message || "Some Error Occurred, But Not Identified.";
                    this.toastr.error(errorMessage);
                }
            );
        } else {
            this.loginForm.controls['userName'].markAsTouched();
            this.loginForm.controls['userName'].markAsDirty();
            this.loginForm.controls['password'].markAsTouched();
            this.loginForm.controls['password'].markAsDirty();
        }
    }

}
